import { WidgetModule } from "@shared/widgets/widget.module";
import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { TranslateModule } from "@ngx-translate/core";
import { AngularMaterialModule } from "@shared/modules/angular-material/angular-material.module";
import { ReactiveFormsModule } from "@angular/forms";
import { ModalApprovalComponent } from "./modal-approval.component";
import { IConfig, NgxMaskDirective, provideNgxMask } from "ngx-mask";

const maskConfig: Partial<IConfig> = {
  validation: false
};

@NgModule({
  declarations: [ModalApprovalComponent],
  imports: [
    CommonModule,
    WidgetModule,
    ReactiveFormsModule,
    TranslateModule,
    AngularMaterialModule,
    NgxMaskDirective
  ],
  exports: [ModalApprovalComponent],
  providers: [provideNgxMask(maskConfig)]
})
export class ModalApprovalModule {}
